'use strict';
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _ActionTypes = require('pricing-pages-unified-ui/constants/ActionTypes');

var _ActionTypes2 = _interopRequireDefault(_ActionTypes);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var initialState = {};

var Promotions = function Promotions() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : initialState;
  var _ref = arguments[1];
  var type = _ref.type,
      payload = _ref.payload;

  switch (type) {
    case _ActionTypes2.default.ELIGIBLE_PROMOTIONS_RECEIVED:
      return payload;
    default:
      return state;
  }
};

exports.default = Promotions;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./js/reducers/Promotions.js
// module id = 394
// module chunks = 3 4 5